import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { GlobalContext } from '../context/GlobalState';

const NewGame = () => {
  const [name, setName] = useState('');
  const [formError, setFormError] = useState('');
  const { game, newGame } = useContext(GlobalContext);
  const history = useHistory();

  const handleNewGame = async () => {
    if (!name.trim()) {
      setFormError('Enter your name first.');
      return;
    }
    setFormError('');
    const gameData = await newGame(name.trim());
    if (gameData?.code) {
      history.push(`/join/${gameData.code}`);
    }
  };

  return (
    <div id="tm__startGame" className="tm2">
      <div className="box" style={{ textAlign: 'left' }}>
        <p>
          <label htmlFor="txt__newGameName">Name:</label>
          <input
            type="text"
            id="txt__newGameName"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </p>

        <button
          className="btn btn-gold"
          onClick={handleNewGame}
          disabled={game?.loading}
        >
          {game?.loading ? 'Creating...' : 'New Game'}
        </button>

        {(formError || game?.error) && (
          <p className="error" role="alert">
            {formError || game.error}
          </p>
        )}
      </div>
    </div>
  );
};

export default NewGame;
